<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 py-1 mb-0 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>{{ $t($route.name, { name: $store.state.studentLabel }) }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0 mt-2">
      <v-col
        v-show="!sessionProp"
        cols="12"
        class="py-1"
        md="3"
      >
        <autocomplete
          v-model="session"
          title="academySession"
          type="academySession"
          :value="session"
        />
      </v-col>
      <v-col
        v-if="session"
        cols="12"
      >
        <v-chip
          class="ma-2 ms-0"
          color="orange"
          label
          text-color="blue-grey darken-4"
        >
          {{ $t('heldingDate') }} {{ session.jdate }}
        </v-chip>
        <v-chip
          class="ma-2 ms-0"
          color="blue"
          label
          text-color="white"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('startTime') }} {{ session.event.start_time }}
        </v-chip>
        <v-chip
          class="ma-2 ms-0"
          color="teal"
          label
          text-color="white"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('eventStartDate') }} {{ session.event.start_date }}
        </v-chip>
        <v-chip
          class="ma-2 ms-0"
          color="blue"
          label
          text-color="white"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('sessionCount') }} {{ session.event.session_count }}
        </v-chip>
        <v-chip
          v-if="session.event.teacher"
          class="ma-2 ms-0"
          color="amber"
          label
          text-color="brown"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('teacher') }} {{ session.teacher.name }}
        </v-chip>
        <v-chip
          v-if="session.event.place"
          class="ma-2 ms-0"
          color="deep-orange"
          label
          text-color="white"
        >
          <v-icon left>
            mdi-office-building-outline
          </v-icon>
          {{ $t('place') }} {{ $t('class') }} {{ session.place.name }}
        </v-chip>
        <v-chip
          v-if="session.event.arrayDays && session.event.arrayDays.length > 0"
          class="ma-2 ms-0"
          color="primary"
          label
          text-color="white"
        >
          {{ $t('daysHolding') }}
        </v-chip>
        <v-chip
          v-for="(day, index) in session.event.arrayDays"
          :key="index"
          color="primary"
          label
          style="margin-left: 1px;margin-right:1px"
          class="px-1"
        >
          <span class="px-1 white--text">
            {{ $t(day) }}
          </span>
        </v-chip>
      </v-col>
    </v-row>
    <v-row class="mx-0 mt-0">
      <v-col
        class="pb-2 px-2"
        cols="12"
      >
        <v-subheader inset>
          {{ $t('eventStudent', {name: $store.state.studentLabel}) }}
        </v-subheader>
        <v-col
          class="pb-0  px-0 pt-0 "
          cols="12"
          style="border: 1px solid #e3e3e3;border-radius: 5px;}"
        >
          <v-skeleton-loader
            v-if="!students || students.length == 0"
            class="mt-2"
            type="list-item-avatar@10"
          />
          <v-list
            v-if="students && students.length > 0"
            style=" height:308px;overflow-y:auto"
          >
            <v-list-item-group
              active-class="blue--text"
              multiple
            >
              <template>
                <v-list-item
                  v-for="(student, i) in students"
                  :key="i"
                  dense
                  style="border-bottom: 1px solid #e3e3e3"
                >
                  <template v-slot:default="{}">
                    <v-list-item-avatar class="my-0">
                      {{ +i + +1 }}
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>
                        <v-chip
                          :color="(student.attendance == 'present' ? 'green' : 'pink')"
                          outlined
                          small
                        >
                          {{ student.name }}
                        </v-chip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-if="student.attendanceStatus"
                              color="light-blue darken-4"
                              outlined
                              v-bind="attrs"
                              class="ms-1"
                              small
                              v-on="on"
                            >
                              {{ student.attendanceStatus.total }}
                            </v-chip>
                          </template>
                          <span>{{ $t('sessionTotalHelding') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-if="student.attendanceStatus"
                              color="green"
                              outlined
                              v-bind="attrs"
                              class="ms-1"
                              small
                              v-on="on"
                            >
                              {{ student.attendanceStatus.present }}
                            </v-chip>
                          </template>
                          <span>{{ $t('countPresent') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-if="student.attendanceStatus"
                              color="red"
                              outlined
                              v-bind="attrs"
                              class="ms-1"
                              small
                              v-on="on"
                            >
                              {{ student.attendanceStatus.absent }}
                            </v-chip>
                          </template>
                          <span>{{ $t('countAbsent') }}</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action class="my-0">
                      <div class="d-flex">
                        <v-switch
                          v-model="student.attendance"
                          inset
                          dense
                          value="present"
                        />
                      </div>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
          <v-card-actions>
            <v-btn
              v-if="students && students.length > 0"
              color="primary"
              class="ms-2"
              :loading="loading"
              @click="submit"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-col>
      </v-col>
    </v-row>
    <v-row />
    <v-snackbar
      v-model="snakbar"
      color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  export default {
    name: 'StudentList',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
    },
    mixins: [General],
    props: ['sessionProp'],
    data: () => ({
      selected: [],
      eventStudentReq: true,
      session: null,
      excelItems: null,
      category: null,
      integratorType: null,
      rangeDate: null,
      registerar: null,
      attractionMethod: null,
      customerStatusItems: null,
      financialStatusItems: null,
      printDialog: false,
      uploadDialog: false,
      accountDialog: false,
      deletDialog: false,
      filter: false,
      financialStatus: null,
      customerStatus: null,
      status: 'active',
      taskindex: 0,
      lead: null,
      refId: null,
      taskItem: null,
      model: null,
      from: 1,
      taskDialog: null,
      taskDialogList: null,
      showSelect: null,
      tag: null,
      temp: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbarColor: null,
      snakbar: false,
      snakbarText: null,
      loading: false,
      options: {
        itemsPerPage: 5,
      },
      deleteItem: null,
      students: [],
      headers: null,
      personnel: null,
      id: null,
      search: null,
      renderTable: null,
      selectedHeaders: [],
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        var app = this
        app.excelItems = []
        const totals = this.items.reduce((acc, d, index) => {
          acc.amount += parseFloat((d.remain ? d.remain.remain : 0))
          app.excelItems.push({
            row: +index + +1,
            name: String(d.name),
            category: (d.category ? d.category.name : ''),
            phone: (d.phone ? String(d.phone) : ''),
            mobile: (d.mobile ? (d.mobile) : ''),
            email: (d.email ? d.email : ''),
            address: (d.address ? d.address : ''),
            remain: (d.remain ? d.remain.remain : ''),
          })
          return acc
        }, {
          amount: 0,
        })
        app.renderTable = true
        return totals
      },
    },
    watch: {
      taskDialogList (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      taskDialog (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      data (val, oldVal) {
        this.model = val.description
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      session (val) {
        if (val) {
          this.students = []
          this.getStudents()
        } else {
          this.students = []
        }
      },
    },
    activated () {
    },
    beforeMount () {
      if (this.sessionProp) {
        this.session = this.sessionProp
      }
    },
    mounted () {
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      if (this.input) {
        this.model = this.input
      }
      // this.getItems()
    },
    methods: {
      removeStudent (item) {
        const i = this.students.indexOf(item)
        if (i > -1) {
          this.students.splice(i, 1)
        }
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'academyStudents/' + item.registerId)
          .then(res => {
            res = res.data
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      submit () {
        if (!this.students) {
          return false
        }
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        var data = {
          setAttendance: 'active',
          session: this.session,
          students: app.students,
        }
        app.$axios.post(this.$endpoint + 'academyStudents', data)
          .then(res => {
            res = res.data
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('alert-created')
            app.snakbar = true
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getStudents () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academyStudents', {
          params: {
            getStudentsAttendance: 'active',
            session: app.session,
          },
        })
          .then(res => {
            res = res.data
            app.students = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
    },
  }
</script>

<style scoped>
.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  padding: 4px 6px !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 32px !important;
}
</style>
